import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Star, ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  const INITIAL = 6;
  const testimonials = [{
    quote: 'Yo estaba completamente perdida y no sabía por dónde empezar. Aquí entendí todo paso a paso y por primera vez sentí que sí era posible. Ya tengo mi primera idea lista para lanzar.',
    name: 'Mariana R.',
    image: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    quote: 'Había visto mil videos y seguía confundida. Aquí te dicen exactamente qué hacer. No pierdes tiempo. Eso fue lo que marcó la diferencia para mí.',
    name: 'Laura G.',
    image: 'https://randomuser.me/api/portraits/women/68.jpg'
  }, {
    quote: 'Pensé que esto era complicado, pero está explicado tan claro que se siente posible desde el primer momento. Me dio seguridad para empezar.',
    name: 'Daniela P.',
    image: 'https://randomuser.me/api/portraits/women/65.jpg'
  }, {
    quote: 'Antes elegía productos por intuición y perdía tiempo. Con esto entendí cómo analizar bien y tomar decisiones con lógica.',
    name: 'Valentina C.',
    image: 'https://randomuser.me/api/portraits/women/33.jpg'
  }, {
    quote: 'Solo con la lista de productos ya entendí por dónde empezar. Eso para mí valió todo. Me ahorró semanas de prueba y error.',
    name: 'Karla S.',
    image: 'https://randomuser.me/api/portraits/women/47.jpg'
  }, {
    quote: 'Me gustó porque no es teoría ni relleno. Es directo, práctico y te dice exactamente qué hacer.',
    name: 'Sofía L.',
    image: 'https://randomuser.me/api/portraits/women/52.jpg'
  }, {
    quote: 'Literalmente pasé de no saber nada a tener un plan claro en pocos días. Eso no lo había logrado con nada antes.',
    name: 'Camila T.',
    image: 'https://randomuser.me/api/portraits/women/89.jpg'
  }, {
    quote: 'Sentí que por primera vez alguien explicó esto para personas normales, sin complicaciones ni palabras difíciles.',
    name: 'Paola D.',
    image: 'https://randomuser.me/api/portraits/women/26.jpg'
  }, {
    quote: 'Me ayudó a dejar de pensar tanto y empezar a actuar. Eso fue lo que más necesitaba.',
    name: 'Gabriela V.',
    image: 'https://randomuser.me/api/portraits/women/71.jpg'
  }, {
    quote: 'El checklist me dio orden total. Antes no sabía ni qué paso seguía, ahora tengo claridad completa.',
    name: 'Natalia F.',
    image: 'https://randomuser.me/api/portraits/women/57.jpg'
  }, {
    quote: 'Por este precio, todo lo que incluye es una locura. Vale muchísimo más. Es de las mejores decisiones que he tomado.',
    name: 'Jessica H.',
    image: 'https://randomuser.me/api/portraits/women/90.jpg'
  }];
  return <section className="bg-brand-white py-24 px-6" data-id="element-877">
      <div className="max-w-7xl mx-auto" data-id="element-878">
        <FadeIn data-id="element-879">
          <div className="text-center mb-16" data-id="element-880">
            <span className="text-4xl mb-4 block" data-id="element-881">💬</span>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green uppercase tracking-wide" data-id="element-882">
              Lo que otras personas están logrando
            </h2>
          </div>
        </FadeIn>

        {(() => {
        const renderCard = (testimonial: (typeof testimonials)[number]) => <div className="bg-brand-beige/40 p-8 rounded-2xl h-full flex flex-col border border-brand-beige hover:border-brand-gold/30 transition-colors" data-id="element-883">
              <div className="flex gap-1 mb-4" data-id="element-884">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-885" />)}
              </div>
              <p className="text-brand-text/90 italic mb-6 flex-grow leading-relaxed" data-id="element-886">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-887">
                <img src={testimonial.image} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover border-2 border-brand-beige" data-id="element-888" />
                <p className="font-semibold text-brand-green" data-id="element-889">
                  – {testimonial.name}
                </p>
              </div>
            </div>;
        return <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-890">
                {testimonials.slice(0, INITIAL).map((testimonial, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-891">
                    {renderCard(testimonial)}
                  </FadeIn>)}
              </div>

              <AnimatePresence initial={false} data-id="element-892">
                {showAll && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.45,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-893">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6" data-id="element-894">
                      {testimonials.slice(INITIAL).map((testimonial, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.4,
                  delay: 0.05 * (index % 6)
                }} data-id="element-895">
                          {renderCard(testimonial)}
                        </motion.div>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>

              {testimonials.length > INITIAL && <div className="text-center mt-12" data-id="element-896">
                  <Button onClick={() => setShowAll(prev => !prev)} className="bg-brand-green hover:bg-brand-green/90 !text-white font-bold px-10 py-4 inline-flex items-center gap-2 ring-1 ring-brand-gold/30" data-id="element-897">
                    <span data-id="element-898">
                      {showAll ? 'VER MENOS OPINIONES' : 'VER MÁS OPINIONES'}
                    </span>
                    {showAll ? <ChevronUp className="w-4 h-4" data-id="element-899" /> : <ChevronDown className="w-4 h-4" data-id="element-900" />}
                  </Button>
                </div>}
            </>;
      })()}
      </div>
    </section>;
}